/* global actionPath, Fw */

(function($, d, g) {
	"use strict";
	
	var comForm;
	
	var resetCaptcha = function() {
		if (g.grecaptcha) g.grecaptcha.reset();
	};
	
	var send = function (recaptchaToken) {
		var $it = $(this);
		var $form = $it.closest("form");
		
		comForm.validateForm($form);
		
		if ($form.hasClass("has-error")) {
			$form.find(".contact-form-error").slideDown(200);
			resetCaptcha();
			return false;
		}
		$form.find(".contact-form-error").slideUp(200);
		
		if (!recaptchaToken) {
			$form.find(".contact-form-error-recaptcha").slideDown(200);
		} else {
			var dataStr = "";
			
			$form.find(".contact-form-error-recaptcha").slideUp(200);
			$it.addClass("processing");
			
			dataStr += $form.serialize();
			
			ajax(actionPath + "contactUs?" + dataStr, _complete, true);
		}
		
		function _complete() {
			$it.removeClass("processing");
			$form.removeClass("is-checked");
			$form[0].reset();
			resetCaptcha();
			comForm.showSuccessPopup("contact-sent-success");
		}
	};

	var init = function (page) {
		comForm = Fw.component.models().form;

		$(".contact-form-btn").each(function(i, btn) {
			Fw.component.models().utils.recaptcha(btn, function (response) {
				send.call(btn, response);
			});
		});
	};
	
	$(g).ready(init);
	
})(jQuery, document, window);
